import { createRouter, createWebHistory } from "vue-router";
import authRoutes from "./routes/authRoutes";
import approverRoutes from "./routes/approverRoutes";
import purchaseRequestApprovalRoutes from "./routes/purchaseRequestApprovalRoutes";
import purchaseOrderApprovalRoutes from "./routes/purchaseOrderApprovalRoutes";
import mainRoutes from "./routes/mainRoutes";
import purchaseRequestRoutes from "./routes/purchaseRequestRoutes";
import purchaseOrderRoutes from "./routes/purchaseOrderRoutes";
import departmentRoutes from "./routes/departmentRoutes";
import supplierRoutes from "./routes/supplierRoutes";
import costCentreRoutes from "./routes/costCentreRoutes";
import budgetTrackingRoutes from "./routes/budgetTrackingRoutes";
import materialGroupRoutes from "./routes/materialGroupRoutes";
import productMeasureTypeRoutes from "./routes/productMeasureTypeRoutes";
import prApprovalMatrixRoutes from "./routes/prApprovalMatrixRoutes";
import poApprovalMatrixRoutes from "./routes/poApprovalMatrixRoutes";
import userManagementRoutes from "../router/routes/userManagementRoutes";
import unauthorizedRoutes from "../router/routes/unauthorizedRoutes";
import coreLangService from "@/CommonVueCore/src/services/langService/langService";
import { WorkingMode } from "@/CommonVueCore/src/constants/globalEnums/WorkingMode";
import { SweetAlertService } from "@/CommonVueCore/src/services/sweetAlert2Service/sweetAlert2Service";
import { inject } from "vue";
import productRoutes from "./routes/productRoutes";
import { useAuthAppStore } from "@/store/stores/authStore";
import { PermissionService } from "@/services/permissionService/permissionService.js";
import reportRoutes from "./routes/reportRoutes";
import currencyRoutes from "./routes/currencyRoutes";
import { AuthService } from "@/services/authService/authService";

const routes = [
  ...authRoutes,
  ...purchaseRequestApprovalRoutes,
  ...purchaseOrderApprovalRoutes,
  //http://cprox.test.yph.inc/purchase-order/approval?id=23&step=6&complexCode=1100
  ...departmentRoutes,
  ...costCentreRoutes,
  ...budgetTrackingRoutes,
  ...productRoutes,
  ...mainRoutes,
  ...purchaseRequestRoutes,
  ...purchaseOrderRoutes,
  ...approverRoutes,
  ...supplierRoutes,
  ...materialGroupRoutes,
  ...productMeasureTypeRoutes,
  ...prApprovalMatrixRoutes,
  ...poApprovalMatrixRoutes,
  ...userManagementRoutes,
  ...unauthorizedRoutes,
  ...reportRoutes,
  ...currencyRoutes,
];

let stringHelpers = null;

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Eğer geri/ileri tuşuna basıldıysa eski pozisyona dön
    if (savedPosition) {
      return savedPosition;
    } else {
      // Normal route değişiminde sayfanın en üstüne git
      return { top: 0 };
    }
  },
});

// router.beforeEach((to, from, next) => {
//   if (stringHelpers === null) {
//     stringHelpers = inject("stringHelpers");
//   }

//   if (
//     window.appsettings !== undefined &&
//     stringHelpers.castToEnum(
//       window.appsettings.AppGlobal.WorkingMode,
//       WorkingMode
//     ) === null
//   )
//     new SweetAlertService().error(
//       "error",
//       "WorkingMode hatalı girilmiş lütfen kontrol edin."
//     );

//   //seçilmiş dili kontrol eder. Eğer ilk giriş ise EN olarak default atar.
//   coreLangService.CheckLang();

//   var name = to.name ? to.name.toLowerCase() : "";

//   let isExpired = useAuthAppStore().getCheckExpired;
//   const permissionService = new PermissionService();
//   let isExistPermission = permissionService.checkPermissionContextUser({ to });

//   console.log("isExistPermission", isExistPermission);

//   if (!isExpired) {
//     if (name == "login") {
//       next({ path: "/" });
//     } else {
//       if (!isExistPermission) {
//         if (name === "home") {
//           next();
//         }
//         next({
//           path: "/errorPage",
//           query: {
//             errorMsg: `You're not authorized this page. Please contact to admin.`,
//             errorCode: 401,
//           },
//         });
//       } else {
//         to.meta.permissions = permissionService.getPermissions({ to });
//         console.log("to.meta.permissions", to.meta.permissions);

//         next();
//       }
//       // next()
//     }
//   } else {
//     useAuthAppStore().setResetToken();
//     useAuthAppStore().setResetParsedToken();

//     if (name == "login") {
//       next();
//     } else {
//       next({ name: "login" });
//     }
//   }
// });

router.beforeEach(async (to, from, next) => {
  if (stringHelpers === null) {
    stringHelpers = inject("stringHelpers");
    if (stringHelpers === null) {
      console.error("stringHelpers could not be injected!");
      return;
    }
  }

  if (
    window.appsettings !== undefined &&
    stringHelpers.castToEnum(
      window.appsettings.AppGlobal.WorkingMode,
      WorkingMode
    ) === null
  ) {
    new SweetAlertService().error("error", window.$t("Invalid_WorkingMode"));
    return;
  }

  coreLangService.CheckLang();

  const name = to.name ? to.name.toLowerCase() : "";
  // burada once storedan kontrol ettik 
  let isExpired = useAuthAppStore().checkExpiredNow();
  if (isExpired) {
    // eger bu kosul saglandiysa refresh token aldik.
    await new AuthService().checkExpireBeforeRequest();
  }
  // sonra refresh token ile dolan expire date i tekrar kontrol ettik.
  isExpired = useAuthAppStore().checkExpiredNow();

  const permissionService = new PermissionService();
  const isExistPermission = permissionService.checkPermissionContextUser({
    to,
  });

  console.log("isExistPermission", isExistPermission);

  if (!isExpired) {
    if (name === "login" && from.name === "login") {
      next(false);
    } else if (name === "login") {
      next({ path: "/" });
    } else if (!isExistPermission) {
      if (name === "home" || name === "unauthorized") {
        next();
      } else {
        next({
          path: "/errorPage",
          query: {
            errorMsg: `You're not authorized for this page. Please contact the admin.`,
            errorCode: 401,
          },
        });
      }
    } else {
      to.meta.permissions = permissionService.getPermissions({ to });
      next();
    }
  } else {
    // Kullanıcının yönlendirileceği durum
    const layout = to.meta?.layout;

    if (layout === "LayoutCommonPage") {
      // LayoutCommon kullanan bir sayfaysa yönlendirme yapma
      next();
    } else {
      // Diğer sayfalar için login'e yönlendir
      useAuthAppStore().setResetToken();
      useAuthAppStore().setResetParsedToken();

      if (to.name === "purchase-request-approval") {
        var queryStr = {
          isRedirectedFromLink: true,
          id: to.query.id,
          step: to.query.step,
          complexCode: to.query.complexCode,
        };
      }

      next(name === "login" ? undefined : { name: "login", query: queryStr });
    }
  }
});

export default router;
